export function detectMobilePlatform({ userAgent = "", platform = "", maxTouchPoints = 0 } = {}) {
  const isTouchMac = platform === "MacIntel" && maxTouchPoints > 1

  if (/iPad|iPhone|iPod/.test(userAgent) || isTouchMac) return "ios"
  if (/Android/i.test(userAgent)) return "android"

  return null
}

export function isIosSafariUserAgent(userAgent = "") {
  return /Safari/i.test(userAgent) && !/(CriOS|FxiOS|EdgiOS|OPiOS|DuckDuckGo|GSA)/i.test(userAgent)
}

export function shouldUseNativeIosSmartAppBanner({ platform, hasNativeSmartAppBanner, userAgent = "" } = {}) {
  return platform === "ios" && hasNativeSmartAppBanner && isIosSafariUserAgent(userAgent)
}
